import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const RD_DEFAULTS = { grid_mobile: 2, grid_tablet: 3, grid_desktop: 4, hero_mode: "fixed", spacing: "normal", font_scale: 100, header_mobile_logo: "compact" };
const Ctx = createContext(RD_DEFAULTS);

// Draft settings for the admin preview iframe arrive via ?rd_preview=<base64 json>; never persisted.
function previewDraft() {
  try {
    const v = new URLSearchParams(window.location.search).get("rd_preview");
    return v ? JSON.parse(atob(v)) : null;
  } catch { return null; }
}

export function ResponsiveProvider({ children }) {
  const [rd, setRd] = useState(() => ({ ...RD_DEFAULTS, ...(previewDraft() || {}) }));
  useEffect(() => {
    if (previewDraft()) return;
    api.get("/site/responsive").then((r) => setRd({ ...RD_DEFAULTS, ...r.data })).catch(() => {});
  }, []);
  useEffect(() => {
    const onAdmin = window.location.pathname.startsWith("/admin");
    document.documentElement.style.fontSize = onAdmin ? "" : `${rd.font_scale}%`;
    document.body.dataset.rdSpacing = rd.spacing;
  }, [rd]);
  return <Ctx.Provider value={rd}>{children}</Ctx.Provider>;
}

export const useResponsive = () => useContext(Ctx);

const MOBILE = { 1: "grid-cols-1", 2: "grid-cols-2" };
const TABLET = { 2: "sm:grid-cols-2", 3: "sm:grid-cols-3" };
const LAPTOP = { 4: "lg:grid-cols-4", 5: "lg:grid-cols-4" };
const DESKTOP = { 4: "xl:grid-cols-4", 5: "xl:grid-cols-5" };
export const gridClass = (rd, sidebar = false) =>
  `grid ${MOBILE[rd.grid_mobile]} ${TABLET[rd.grid_tablet]} ${sidebar ? "lg:grid-cols-3" : LAPTOP[rd.grid_desktop]} ${sidebar && rd.grid_desktop === 5 ? "xl:grid-cols-4" : DESKTOP[rd.grid_desktop]} gap-[var(--rd-gap)]`;
